<template>
    <div class="loader" :data-active="active">
        <div class="loader__wrap">
            <div class="loader__loader"></div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        active: Boolean
    },
}
</script>

<style lang="scss" scoped>
.loader {
    display: flex;
    width: 100%;
    height: auto;
    justify-content: center;
    opacity: 0.75;
    &[data-active="true"] {
        .loader__loader {
            //animation: l1 1s infinite;
        }
    }
}
.loader__loader {
  width: 20px;
  aspect-ratio: 1;
  border-radius: 50%;
  background: #139865;
  box-shadow: 0 0 0 0 transparentize(#139865, 0.25);
  animation: l1 1s infinite;
}
@keyframes l1 {
    100% { box-shadow: 0 0 0 30px transparentize(#139865, 1) }
}
</style>